import type { DashboardComposition } from './types/dashboard-composition.ts';
import type { ToolAppSurfaceDefinition } from './types/tool-apps.ts';

/** Tool Apps use the same presentation engine as Forge previews and flow results. */
export const buildToolAppComposition = (surface: ToolAppSurfaceDefinition): DashboardComposition => {
  let row = 0;
  let col = 0;
  const spans = { full: 6, half: 3, third: 2 } as const;
  return {
    version: '1.0', metadata: { title: surface.title, visibility: 'private' },
    layout: { type: 'grid', columns: 6 },
    views: [...surface.views].sort((a, b) => a.order - b.order).map((binding) => {
      const colSpan = spans[binding.width];
      if (col + colSpan > 6) { row += 1; col = 0; }
      const placement = { position: { row, col, colSpan } };
      col += colSpan;
      return { id: binding.id, viewDefinition: binding.viewDefinition, placement };
    }),
  };
};

import type { ToolAppDefinition } from './types/tool-apps.ts';
import type { ResultPayload } from './types/result-composition.ts';
import { DEFAULT_VIEW_SCHEMA_VERSION, type AnyViewEnvelope } from './types/views.ts';

export const buildReadModelTabs = (definition: ToolAppDefinition, result?: ResultPayload | null) =>
  definition.surfaces.map((surface) => ({
    id: surface.key, label: surface.title, scope: 'run' as const,
    composition: buildToolAppComposition(surface),
    viewEnvelopesByInstanceId: Object.fromEntries(surface.views.map((binding): [string, AnyViewEnvelope] => [binding.id,
      result?.tabs.find((tab) => tab.id === surface.key)?.sections.find((section) => section.id === binding.id)?.envelope
      ?? { view_type: 'fallback_panel', schema_version: DEFAULT_VIEW_SCHEMA_VERSION, data: {
        title: binding.viewDefinition.displayMeta.title ?? surface.title,
        message: 'Testez les sources pour voir les données accessibles avec votre compte.', reason: 'source_no_data',
      } },
    ])),
  }));
